module.exports = __webpack_public_path__ + "static/media/Pump_On.4173e60f.png";